import AssignmentIcon from '@mui/icons-material/Assignment';
import NotesIcon from '@mui/icons-material/Notes';
import FaceIcon from '@mui/icons-material/Face';
import GroupIcon from '@mui/icons-material/Group';

/**
 * Event type configuration
 * Centralizes icon, color, and display logic for each event type
 */
export const EVENT_TYPES = {
  assignment: {
    icon: AssignmentIcon,
    color: 'warning.main',
    label: 'Assignment'
  },
  note: {
    icon: NotesIcon,
    color: 'info.main',
    label: 'Note'
  },
  match: {
    icon: FaceIcon,
    color: 'primary.main',
    label: 'Face Match'
  },
  group_match: {
    icon: GroupIcon,
    color: 'primary.main',
    label: 'Group Match'
  }
};

/**
 * Get event type configuration
 * @param {string} eventType - The event type
 * @returns {Object} Configuration object with icon, color, and label
 */
export function getEventTypeConfig(eventType) {
  return EVENT_TYPES[eventType] || {
    icon: NotesIcon,
    color: 'grey.500',
    label: 'Unknown'
  };
}

/**
 * Format event date and time for display
 * @param {string} dateString - ISO date string
 * @returns {string} Formatted date and time
 */
export function formatEventDateTime(dateString) {
  const eventDate = new Date(dateString);
  const dateStr = eventDate.toLocaleDateString();
  const timeStr = eventDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  return `${dateStr} ${timeStr}`;
}
